import React from "react";

const Pagination = ({ totalPages, currentPage, handlePageChange }) => {
    if (totalPages <= 1) return null;
    return (
        <div className="pagination">
            {Array.from({ length: totalPages }).map((_, pageIndex) => {
                const pageNumber = pageIndex + 1;
                return (
                    <button
                        key={pageNumber}
                        className={`page-btn ${currentPage === pageNumber ? "active" : ""}`}
                        onClick={() => handlePageChange(pageNumber)}
                    >
                        {pageNumber}
                    </button>
                );
            })}
        </div>
    );
};

export default Pagination;
